export const serverURL = (
  strings: TemplateStringsArray,
  ...values: unknown[]
): string => {
  const baseURL =
    import.meta.env.VITE_API_ENDPOINT || "https://nos.noahs-farm.xyz/api";
  let result: string = strings[0];
  for (let i = 0; i < values.length; i++) {
    result += String(values[i]) + strings[i + 1];
  }

  const normalizedBase: string = baseURL.endsWith("/")
    ? baseURL.slice(0, -1)
    : baseURL;
  const normalizedPath: string = result.startsWith("/") ? result : "/" + result;

  return normalizedBase + normalizedPath;
};
